import { Observable } from 'rxjs';

export interface PdfExportBase {
  state: PdfExportState;
  filename: string;
}

export interface PdfExportComplete extends PdfExportBase {
  state: PdfExportState.Completed;
  downloadLink: string;
}

export interface PdfExportLoading extends PdfExportBase {
  state: PdfExportState.New | PdfExportState.Enqueue;
}

export interface PdfExportFailed extends PdfExportBase {
  state: PdfExportState.Failed;
  error: Error;
}

export type PdfExport = PdfExportComplete | PdfExportFailed | PdfExportLoading;

export enum PdfExportState {
  Completed = 'completed',
  Enqueue = 'enqueued',
  New = 'new',
  Failed = 'failed',
}

export interface PdfExportJob {
  complete$: Observable<boolean>;
  error$: Observable<Error | null>;
  link$: Observable<string | null>;
}
